import React, { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import moment from 'moment';
import Currency from 'react-currency-formatter';
import attachDocument from '../../../../layout/Logistic/Attachment';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  Container,
  SubContainer,
  Title,
  ItemDetails,
  Left,
  Right,
  TitleDetails,
  Details,
  IconInformation,
  IconInformationBlue,
  IconPix,
  ToolTipText,
  ToolTipButton,
  QrCodeStyle
} from './styles';
import information from '~/assets/images/information.svg';
import informationBlue from '~/assets/images/information-blue.svg';
import pix from '~/assets/images/pix-blue.svg';
import Loading from '~/components/layout/Loading';
import { analytics, logEvent } from '~/services/firebaseConfig';

export default function({ data, openModal, handleShowButton }) {
  const installment = data;
  const [fileAttached, setFileAttached] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [selectedPixCode, setSelectedPixCode] = useState("")

  const logisticPaymentReducer = useSelector(state => state.logisticPaymentReducer);

  useEffect(()=>{
    if(installment && installment.amountRemaining > 0 && installment.paymentStatus === 'OP') {
      handleShowButton({id: data.invoice.invoiceId, status:fileAttached })
    }
  },[fileAttached])


  const handleCopyToClickBoard = useCallback((selectedPixCode) => {
    logEvent(analytics, "copiando_linha_digitavel");
    setSelectedPixCode(selectedPixCode);
  },[selectedPixCode]);

  let qrcodeData = null
  try {
    if ('qrcodeData' in installment) {
      qrcodeData = JSON.parse('{' + installment?.qrcodeData + '}');
    }
  } catch (error) {
    console.log('Erro ao converter QRCode');
  }

  return (
    installment && installment.amountRemaining > 0 && installment.paymentStatus === 'OP' ? (
      <Container className="mb-3" style={{ cursor: !installment.paymentTypeBoleto ? "pointer" : "normal" }}>
        {isLoading ? (
          <Loading margin={"0px 0px 0px 48%"} />
        ) : (
          <SubContainer>
            <Left>
              <Title>{moment(installment.dueDate).format("MMMM/YYYY")}</Title>
              <ItemDetails>
                <TitleDetails>Vencimento:</TitleDetails>
                {moment(installment.dueDate).format('DD/MM/YYYY')}
              </ItemDetails>
            </Left>

            <Right>
              <QrCodeStyle>
                {qrcodeData?.dados_qrcode?.emv && (
                  <CopyToClipboard text={qrcodeData?.dados_qrcode?.emv}>
                    <ToolTipButton
                      onClick={() => {
                        handleCopyToClickBoard(
                          qrcodeData?.dados_qrcode?.emv
                        );
                      }}
                      data-tip
                      data-for={data.invoice.invoiceId}
                    >
                      <img src={pix} style={IconPix} alt="Pix" />
                    </ToolTipButton>
                  </CopyToClipboard>
                )}
              </QrCodeStyle>
              {selectedPixCode === qrcodeData?.dados_qrcode?.emv ? (
                <ReactTooltip
                  id={data.invoice.invoiceId}
                  place="right"
                  type="dark"
                  effect="solid"
                >
                  <ToolTipText>Copiado</ToolTipText>
                </ReactTooltip>
              ) : (
                <ReactTooltip
                  id={data.invoice.invoiceId}
                  place="right"
                  type="dark"
                  effect="solid"
                >
                  <ToolTipText>Clique para copiar</ToolTipText>
                </ReactTooltip>
              )}
              <div onClick={() => openModal()}>
                <img src={informationBlue} style={IconInformationBlue} alt="Info Icon" />
              </div>
              <Title style={{fontSize: 15}}>
                <Currency
                  quantity={installment.amountOriginal}
                  currency="BRL"
                  locale="pt"
                />
              </Title>
              <Details
                color={fileAttached}
                onClick={() => {
                  attachDocument(logisticPaymentReducer.order.id, setFileAttached, setIsLoading);
                }}
              >
                Anexar comprovante
                <img src={information} style={IconInformation} alt="Info Icon" />
              </Details>
            </Right>
          </SubContainer>
        )}
      </Container>
    ) : null
  );
}
